export class AddUpdateAssessmentViolationController {
    /*@ngInject*/
    constructor($rootScope, $timeout, candidateService, modalService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.candidateService = candidateService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //variables
        this.proctoringIssueReasons = ['No Images', 'Partial Images', 'Images Not Clear', 'Same Images Recorded', 'Other'];
        this.proctoringViolationReasons = ['Multiple Faces', 'Window/Time Violation', 'Other'];
        this.reason = [];
        this.isReportUpdateInProgress = false;
        this.comment = '';
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.assessmentInfoToModify = angular.copy(this.assessmentInfo.assessmentReportInfoList[this.assessmentInfo.assessmentReportInfoList.length - 1]);
        if (_.isNull(this.assessmentInfoToModify.type)) {
            this.assessmentInfoToModify.type = 'Proctoring Issue';
        }
        this.onTypeChanged();
        if (this.assessmentInfoToModify.commentDto) {
            this._scrollToLastComment();
        }
    }
    onTypeChanged() {
        if (this.assessmentInfoToModify.type == 'Proctoring Issue') {
            this.reasons = this.proctoringIssueReasons;
            this.assessmentInfoToModify.isViolation = true;
        }
        else if (this.assessmentInfoToModify.type == 'Proctoring Violation') {
            this.reasons = this.proctoringViolationReasons;
            this.assessmentInfoToModify.isViolation = true;
        }
        else {
            this.reasons = [];
            this.assessmentInfoToModify.reason = "";
            this.assessmentInfoToModify.isViolation = false;
        }
    }
    _scrollToLastComment() {
        this.$timeout(() => {
            let totalComments = this.assessmentInfo.assessmentReportInfoList.length - 1;
            let lastCommentElementId = this.assessmentInfoToModify.commentDto.id + "-" + totalComments;
            scrollIntoView(document.getElementById(lastCommentElementId), { behavior: "smooth", block: "end", scrollMode: "if-needed" });
        }, 200);
    }
    cancel() {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }
    updateAssessment() {
        this.isReportUpdateInProgress = true;
        this.assessmentInfoToModify.commentDto = { comment: this.comment, user: { firstName: this.$rootScope.userDetails.firstname, lastName: this.$rootScope.userDetails.lastname } };
        let generatingReportDialog = bootbox.dialog({
            message: '<span class="text-center" style="display: flex;align-items: center;justify-content: center;"><span style="margin-right:10px">Updating Report</span><i class="fa fa-spinner fa-spin"></i></span>',
            closeButton: false
        });
        this.candidateService.updateCandidateReportDetails(this.companyId, this.assessmentInfo.candidateAssessmentDetailId, this.assessmentInfoToModify, (data) => {
            // this.assessmentInfo = angular.copy(data);
            this.isReportUpdateInProgress = false;
            generatingReportDialog.modal('hide');
            this.alertsAndNotificationsService.showBannerMessage(data.statusMessage, 'success');
            // if (this.assessmentInfoToModify.addProctoringImagesToReport) {
            //     this.alertsAndNotificationsService.showBannerMessage('Report has been regenerated with Proctoring flag turned on', 'success');
            // } else {
            //     this.alertsAndNotificationsService.showBannerMessage('Report updated successfully', 'success');
            // }
            this.successCallback();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getUserConfirmation(comment) {
        this._launchDeleteCommentConfirmation(comment);
    }
    _launchDeleteCommentConfirmation(comment) {
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: "Deleting the comment (and any associated icon) entered. Are you sure to continue?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._deleteComment(comment);
                }
            }
        });
    }
    _deleteComment(comment) {
        this.candidateService.deleteCommentFromCandidateReportDetails(this.assessmentInfo.candidateAssessmentDetailId, comment.id, (data) => {
            this.assessmentInfo = data;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fas fa-check fa-fw fa-lg'></i><strong>Comment Deleted!</strong></div>",
                message: 'Comment Deleted successfully.',
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }, (error) => {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-danger' style='margin-bottom: 0px;'><i class='fa fa-times-circle fa-fw fa-lg'></i><strong>Comment Delete Failed!</strong></div>",
                message: error.message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        });
    }
    receiveFormalizedComment(event) {
        this.comment = event;
    }
    onVoiceTranscript(transcript) {
        if (this.comment) {
            this.comment += ' ' + transcript;
        }
        else {
            this.comment = transcript;
        }
    }
}
AddUpdateAssessmentViolationController.$inject = ['$rootScope', '$timeout', 'candidateService', 'modalService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-update-assessment-violation.html';
import * as TEMPLATE from 'raw-loader!./add-update-assessment-violation.html';
export const AddUpdateAssessmentViolationComponent = {
    selector: 'addUpdateAssessmentViolation',
    component: {
        bindings: {
            assessmentInfo: '<',
            successCallback: '&',
            cancelCallback: '&'
        },
        controller: AddUpdateAssessmentViolationController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/reports/reviewReports/addUpdateAssessmentViolation/add-update-assessment-violation.html'
    }
};
//# sourceMappingURL=add-update-assessment-violation.component.js.map